import { render, staticRenderFns } from "./TopStylistSources.vue?vue&type=template&id=89ba5e84&scoped=true"
import script from "./TopStylistSources.vue?vue&type=script&lang=js"
export * from "./TopStylistSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ba5e84",
  null
  
)

export default component.exports